import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { useBreakpoint } from "gatsby-plugin-breakpoints";
import { getMediaUrl } from "../../utils/media";

import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";

const slickSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: false,
  variableWidth: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    }
  ]
};

const compareAwards = (a, b) => {
  const aMenuOrder = Number.isFinite(a.menuOrder) ? a.menuOrder : 0;
  const bMenuOrder = Number.isFinite(b.menuOrder) ? b.menuOrder : 0;

  if (aMenuOrder !== bMenuOrder) {
    return aMenuOrder - bMenuOrder;
  }

  const aDate = a.date ? new Date(a.date).getTime() : 0;
  const bDate = b.date ? new Date(b.date).getTime() : 0;

  if (aDate !== bDate) {
    return aDate - bDate;
  }

  return String(a.id).localeCompare(String(b.id));
};

const AwardCats = ({ awardCat, awardCatTitle }) => {
  const [showFilter, setShowFilter] = useState(false);
  const breakpoints = useBreakpoint();
  const awards =
    awardCat && awardCat[0] && awardCat[0].awards && awardCat[0].awards.nodes
      ? [...awardCat[0].awards.nodes].sort(compareAwards)
      : [];

  const updatePosts = e => {
    if (awards.length > 3) {
      setShowFilter(true);
    } else {
      setShowFilter(false);
    }
  };
  useEffect(() => {
    updatePosts();
  }, []);

  return (
    <section className="content award-block">
      <div className="content-block clearfix">
        <div className="eighty-spacer"></div>
        <div className="centered-content-container">
          <div className="centered-title-holder">
            <span>
              {awardCatTitle ? awardCatTitle : "Proud of our Achievements"}
            </span>
          </div>
        </div>

        {breakpoints.sm ? (
          <div className="award-slick-container">
            <Slider
              className="slick-featured-card-container"
              {...slickSettings}
            >
              {awards.length
                ? awards.map((prod, index) => (
                    <div
                      className="slick-flex-mob specialist-car-finance"
                      key={index}
                    >
                      <div className="award-img-container">
                        <img
                          src={getMediaUrl(prod.featuredImage)}
                          alt={prod.featuredImage.altText}
                          title={prod.featuredImage.title}
                        ></img>
                      </div>
                    </div>
                  ))
                : null}
            </Slider>
          </div>
        ) : (
          <>
            {showFilter ? (
              <div className="award-slick-container">
                <Slider
                  className="slick-featured-card-container"
                  {...slickSettings}
                >
                  {awards.length
                    ? awards.map((prod, index) => (
                        <div
                          className="slick-flex-mob specialist-car-finance"
                          key={index}
                        >
                          <div className="award-img-container">
                            <img
                              src={getMediaUrl(prod.featuredImage)}
                              alt={prod.featuredImage.altText}
                              title={prod.featuredImage.title}
                            ></img>
                          </div>
                        </div>
                      ))
                    : null}
                </Slider>
              </div>
            ) : (
              <div className="award-slick-container">
                <div className="slick-list draggable">
                  <div
                    className="slick-track"
                    style={{ opacity: "1", width: "960px" }}
                  >
                    {awards.length
                      ? awards.map((prod, index) => (
                          <div
                            className="slick-flex-mob specialist-car-finance"
                            key={index}
                          >
                            <div className="award-img-container">
                              <img
                                src={getMediaUrl(prod.featuredImage)}
                                alt={prod.featuredImage.altText}
                                title={prod.featuredImage.title}
                              ></img>
                            </div>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <div className="eighty-spacer"></div>
    </section>
  );
};

export default AwardCats;
